
class MegaMenu extends HTMLElement {
    constructor() {
        super();

        this.isMobile = window.innerWidth < 750 ? true : false;
    
        this.setupEventsListener();

        this.setupEventsListernerMobile();
    

        this.menuIsOpen = false;
        this.menuBtnContainer = document.querySelector('.header-v2__menu');
        this.bodyContainer = document.querySelector('body'); 

    }

    

    setupEventsListener() {
        this.menuBtn = document.querySelector('[data-open="menu"]');
        this.menuBtn.addEventListener('click', this.toggleMenu.bind(this));

        var itemMenuOpenBtn = document.querySelectorAll('[mega-menu-open]');

        itemMenuOpenBtn.forEach(
            (button) => button.addEventListener('click', this.openItemMenu.bind(this))
        );

      document.querySelector('body').addEventListener('click', function(e) {
        console.log(e.target);
        let bottom_menu = document.querySelector('#section-v2-mega-menu').getBoundingClientRect().bottom;
        let bottom_click = e.clientY;

        console.log(bottom_menu, bottom_click);

        if (bottom_click > bottom_menu && this.menuIsOpen) {
          this.toggleMenu();
        }
      }.bind(this));
    }

    setupEventsListernerMobile() {
        this.mobileToggleButtons = document.querySelectorAll('[data-mm-mobile]');
        this.mobileToggleList = document.querySelectorAll('[data-mm-mobile-toggle]');

        this.mobileToggleButtons.forEach(
            (button) => button.addEventListener('click', this.openToggleMenu.bind(this))
        )
    }

    removeEventsListener() {

    }

    openToggleMenu(event) {
        var open_item = event.currentTarget.getAttribute('data-mm-mobile');
        var is_open = event.currentTarget.classList.contains('actif');

        this.mobileToggleButtons.forEach((button) => button.classList.remove('actif'));
        document.querySelectorAll('.mega-menu-mobile__item > .text--medium').forEach((button) => button.classList.remove('subtitle'));
        this.mobileToggleList.forEach((list) => list.classList.remove('actif'));

        if (!is_open) {
            document.querySelector('[data-mm-mobile-toggle="' + open_item + '"]').classList.add('actif');
            event.currentTarget.classList.add('actif');
            document.querySelectorAll('.mega-menu-mobile__item > .text--medium').forEach((button) => button.classList.add('subtitle'));
            event.currentTarget.classList.remove('subtitle');
        }
    }

    toggleMenu() {
        if (this.menuIsOpen) {
            this.menuIsOpen = false;
            this.menuBtnContainer.classList.remove('actif');
            this.bodyContainer.classList.remove('mega-menu-open');
        } else {
            this.menuIsOpen = true;
            this.menuBtnContainer.classList.add('actif');
            this.bodyContainer.classList.add('mega-menu-open');

        }
    }

    openItemMenu(event) {
        var is_actif = event.target.classList.contains('mega-menu-actif');
        var menu_to_open = event.target.getAttribute('mega-menu-open');

        document.querySelectorAll('.mega-menu__slide').forEach((elem) => (elem.classList.add('hidden')));
        document.querySelectorAll('[data-mega-menu] .text--medium').forEach((elem) => elem.classList.remove('mega-menu-actif'));
        

        if (is_actif) {
            document.querySelectorAll('[data-mega-menu] .text--medium').forEach((elem) => elem.classList.remove('subtitle-30'));    
        } else {
            document.querySelectorAll('[data-mega-menu] .text--medium').forEach((elem) => elem.classList.add('subtitle-30'));
            event.target.classList.remove('subtitle-30');
            event.target.classList.add('mega-menu-actif');
            document.querySelector('[data-mega-menu-item="' + menu_to_open + '"]').classList.remove('hidden');
        }
    }
}

customElements.define('mega-menu', MegaMenu);
  